import EditableRow from './EditableRow';

export default EditableRow;
